<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Credit Adjustments</v-toolbar-title>
    <v-spacer/>
    <span class="white--text caption font-weight-normal mr-3">Transacting Currency: {{Currency[0].CurrencyName}}</span>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    :headers="headers"
    :fixed-header="true"
    :items="confirmedCreditAdjustments ? CreditAdjustments : CreditAdjustments.filter(a => a.CheckerID === 0)"
    sort-by="MakeDate"
    sort-desc
    :search="search"
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
     
      <!-- rejection dialog  -->
          <v-dialog persistent v-model="rejectionDialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
              </v-card-title>

              <v-card-text>
                <v-select
                  filled dense
                  v-model="RejectionStatus"
                  :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="RejectionReasonDescription"
                  item-value="RejectionReasonID"
                  label="Rejection Reasons"
                ></v-select>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="update()">ok</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New Credit Adjustment</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col class="pb-0">
          <v-text-field
            light dense filled
            color="#2A353D"
            label="Transaction Ref"
            disabled
          ></v-text-field>

          <v-text-field
            :value="currentSystemDate.DayDate"
            label="Transaction Date"
            append-icon="mdi-calendar-month"
            readonly
            dense filled color="#2A353D"
          ></v-text-field>

          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="credit_adjustment.ValueDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="credit_adjustment.ValueDate"
                label="Value Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                :error-messages="errors"
                :rules="DateRules"
                dense filled color="#2A353D"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker color="#2A353D" v-model="credit_adjustment.ValueDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu.save(credit_adjustment.ValueDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="credit_adjustment.Reference"
            label="Reference"
            placeholder="----"
            required
            :rules="[
              v => v ? (v && v.length <= 20) || 'field must be less than 20 characters' : null
            ]"
          ></v-text-field>
        </v-col>
        <v-col class="pb-0">
          <v-select
            filled dense @change="getBalances(credit_adjustment)"
            v-model="credit_adjustment.AccountID"
            :items="allClientAccounts.filter(a => a.CurrencyID === Currency[0].CurrencyID && a.CallAccountTypeID !== 2 && a.CallAccountTypeID !==  3 && a.CallAccountTypeID !==  4 && a.CheckerID != 0 && a.RejectionID == 0)"
            :item-text="item => item.tblclient.Forename + ` ` + item.tblclient.MajorName +` - ` + item.AccountNumber"
            placeholder="----"
            item-value="AccountID"
            label="Client Account"
          ></v-select>
          <v-row>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense filled
                :value="balances.Available != null ? Number(balances.Available).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Available Balance"
                placeholder="----"
                readonly
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense filled
                :value="balances.Actual != null ? Number(balances.Actual).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Actual Balance"
                placeholder="----"
                readonly
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>              
            </v-col>
          </v-row>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="credit_adjustment.TransactionValue"
            label="Transaction Value"
            required
            type="number"
            :rules="TextFieldRules"
            placeholder="--.--"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="credit_adjustment.Narration"
            label="Narration"
            required placeholder="----"
            :rules="[
              v => !!v || 'field is required',
              v => (v && v.length <= 100) || 'field must be less than 100 characters'
            ]"
          ></v-text-field>
          <div class="text-right mb-4">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
            <v-btn class="white--text" small color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              submit
            </v-btn>          
          </div>
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
          
            <v-toolbar-title class="d-flex flex-row grey--text subtitle-1 font-weight-normal">Credit Adjustment : {{currentCreditAdjustment.DealNumber.toUpperCase()}}</v-toolbar-title>
            
            <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentCreditAdjustment.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span v-if="currentCreditAdjustment.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentCreditAdjustment.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentCreditAdjustment.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
       </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col class="pb-0">
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="currentCreditAdjustment.DealNumber"
            label="Transaction Ref"
            readonly
          ></v-text-field>
          <v-text-field
            v-model="currentCreditAdjustment.TransactionDate"
            label="Transaction Date"
            append-icon="mdi-calendar-month"
            readonly
            dense filled color="#2A353D"
          ></v-text-field>
          <v-text-field
            v-model="currentCreditAdjustment.ValueDate"
            label="Value Date"
            append-icon="mdi-calendar-month"
            readonly
            dense filled color="#2A353D"
          ></v-text-field>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="currentCreditAdjustment.Reference"
            label="Reference"
            readonly
          ></v-text-field>
        </v-col>
        <v-col class="pb-0">
          <v-select
            filled dense readonly
            v-model="currentCreditAdjustment.AccountID"
            :items="allClientAccounts.filter(a => a.CurrencyID === Currency[0].CurrencyID && a.CallAccountTypeID !== 2 && a.CallAccountTypeID !==  3 && a.CallAccountTypeID !==  4 && a.CheckerID != 0 && a.RejectionID == 0)"
            :item-text="item => item.tblclient.Forename + ` ` + item.tblclient.MajorName +` - `+item.AccountNumber"
            item-value="AccountID"
            label="Client Account"
          ></v-select>
          <v-row v-if="currentCreditAdjustment.CheckerID == 0">
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense filled
                :value="balances.Available != null ? Number(balances.Available).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Available Balance"
                readonly placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense filled
                :value="balances.Actual != null ? Number(balances.Actual).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                color="#2A353D"
                label="Actual Balance"
                readonly placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense filled
                :value="Number(currentCreditAdjustment.AvailAtTxn).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                color="#2A353D"
                label="Available Balance when transaction was captured"
                readonly
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0 pt-0">
              <v-text-field
                light dense filled
                :value="Number(currentCreditAdjustment.ActualAtTxn).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                color="#2A353D"
                label="Actual Balance when transaction was captured"
                readonly
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-text-field
            light dense filled
            color="#2A353D"
            :value="Number(currentCreditAdjustment.TransactionValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            label="Transaction Value"
            readonly
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="currentCreditAdjustment.Narration"
            label="Narration"
            readonly
          ></v-text-field>
          <div class="text-right mb-4">
            <v-btn class="white--text" small color="#2A353D" @click="closeEdit()">close</v-btn>
          </div>
        </v-col>

        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-dialog persistent v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="update(); close()">ok</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container row>
        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedCreditAdjustments" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-show="confirmedCreditAdjustments" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Credit Adjustments.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Credit Adjustments.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-show="confirmedCreditAdjustments" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency)">

          <v-list-item-title>
            {{ Currency.CurrencyName }}
          </v-list-item-title>

          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-show="!confirmedCreditAdjustments" @click="confirmedCreditAdjustments = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedCreditAdjustments && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveCreditAdjustment(item, index); update()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedCreditAdjustments && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="reject(); setActiveCreditAdjustment(item, index)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        small outlined
        @click="setActiveCreditAdjustment(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
    </template>

    <template v-slot:item.AccountID="{ item }">
      {{getAccountName(item.AccountID)}}
    </template>

    <template v-slot:item.TransactionDate="{ item }">
      {{ item.TransactionDate | moment("DD MMM YYYY") }}
    </template> 

    <!-- <template v-slot:item.ValueDate="{ item }">
      {{ item.ValueDate | moment("DD MMM YYYY") }}
    </template>  -->

    <!-- <template v-slot:item.MakeDate="{ item }">
      {{ item.MakeDate | moment("DD MMMM YYYY") }}
    </template> -->

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import dealingService from '../services/dealing.service';
import transactionService from '../services/transaction.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  name: 'credit_adjustments',

  data () {
    return {
      confirmedCreditAdjustments: true,
      edit: false,
      create:false,
      permitted: null,
      permitted_dialog: true,
      message: '',
      // initiallisation of the view variable 
      view: false,
      rejectionDialog: false,
      RejectionStatus: 0,
      menu: false,
      menu_1: false,
      dialog: false,
      search: '',
      valid: true,
      loading: false,
      content: '',
      currentCreditAdjustment: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Ref Number',
          align: 'start',
          sortable: false,
          value: 'DealNumber'
        },
        { text: 'Account', value: 'AccountID', sortable: true },
        { text: 'Transaction Date', value: 'TransactionDate', sortable: true },
        // { text: 'Value Date', value: 'ValueDate', sortable: true },
        // { text: 'Date Created', value: 'MakeDate', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      DateRules: [
        v => !!v || 'field is required',
        v => (v <= this.currentSystemDate.DayDate) || 'Date cannot be after Transaction Date',
        v => (v >= this.currentSystemDate.DayDate.split('-')[0] + '-' + this.currentSystemDate.DayDate.split('-')[1] + '-01') || 'Date has to be within the month',
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      credit_adjustment: {},
      CurrencyId: 0,
      balances: {},
      errors: [],
    }
  },

  computed: {
    ...mapGetters([
      "allCreditAdjustments",
      "allApplicationDefaults",
      "allClientAccounts",
      "allCurrencies",
      "allTransactionCodes",
      "allAccountBalances",
      "allRejectionReasons",
      "currentSystemDate",
      "allUsers",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    CreditAdjustments() {
      return this.allCreditAdjustments.filter(a => this.allClientAccounts.filter(allClientAccounts => allClientAccounts.CurrencyID == this.Currency[0].CurrencyID).map(allClientAccounts => allClientAccounts.AccountID).includes(a.AccountID));
    },
    Currency() {
      return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
    },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 603).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 603).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 603).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 603).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  watch: {
    'credit_adjustment.ValueDate': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          var data = {
            Date: newValue,
          };

          dealingService.checkIsWeekendHoliday(data)
          .then(response => {
            this.errors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
          })        
        }
      },
      deep: true
    }
  },

  created(){
    this.CurrencyId = this.allApplicationDefaults[0].CurrencyID
  },

  methods: {
    ...mapActions([
      "createTransaction",
      "updateTransaction"
    ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.loading = true;
        this.credit_adjustment.MakerID = this.currentUser.SecurityUserID,
        this.credit_adjustment.CheckerID = this.CheckerID,
        this.credit_adjustment.LastUserID = this.currentUser.SecurityUserID,
        this.credit_adjustment.TransactionDate = this.currentSystemDate.DayDate,
        this.credit_adjustment.TransactionCodeID = 3,
        this.credit_adjustment.IsDebit = this.allTransactionCodes.filter(a => a.TransactionCodeID == 3).map(a => a.IsDebit).toLocaleString(),
        this.credit_adjustment.AvailAtTxn = this.balances.Available,
        this.credit_adjustment.ActualAtTxn = this.balances.Actual,

        this.createTransaction(this.credit_adjustment)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newTransaction',
            data: response.data
          });
          this.loading = false;
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })        
      }
    },

    async update() {
      this.message = '';
      this.currentCreditAdjustment.CheckerID = this.currentUser.SecurityUserID,
      this.currentCreditAdjustment.LastUserID = this.currentUser.SecurityUserID,
      this.currentCreditAdjustment.CheckDate = new Date(),
      this.currentCreditAdjustment.updatedAt = new Date(),
      this.currentCreditAdjustment.RejectionID = this.RejectionStatus,
      this.updateTransaction(this.currentCreditAdjustment)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updTransaction',
          data: this.currentCreditAdjustment
        });
        
        this.message = response.data.message
        this.closeEdit()
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })        
    },

    getBalances(item) {
      this.message = '';
      var data ={
        AccountID: item.AccountID,
        EffectiveDate: this.currentSystemDate.DayDate
      }
      if (item.AccountID != null) {
        transactionService.getAccountBalances(data.AccountID, data)
        .then(response => {
          this.balances = response.data[0]
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Credit Adjustments", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Credit Adjustments.pdf')
      }
    },

    allowedDates: val => val <= new Date().toISOString().split('T')[0],

    mapCurrency(currency) {
      return this.CurrencyId = currency.CurrencyID
    },

    getAccountName(id) {
      return this.allClientAccounts.filter(a => a.AccountID === id).map(a => a.tblclient.MajorName).toLocaleString() + ` ` + this.allClientAccounts.filter(a => a.AccountID === id).map(a => a.tblclient.Forename).toLocaleString() + ` - ` + this.allClientAccounts.filter(a => a.AccountID === id).map(a => a.AccountNumber).toLocaleString()
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedCreditAdjustments = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.balances = {}
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.balances = {}
      this.credit_adjustment = {}
      this.create = false
    },

    reject () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.RejectionStatus = 0
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    setActiveCreditAdjustment (item, index) {
      this.currentCreditAdjustment = item;
      this.currentIndex = index;

      this.getBalances(this.currentCreditAdjustment)
    },
  },

  mounted () {
    UserService.isCreditAdjustment().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedCreditAdjustments", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
